import * as types from './types'
import { AnyAction } from 'redux'
import { IDistributor, IDistributorResponseData } from '@cbgms/api'

const defaultDistributorState: IDistributor | null = null

export const distributor = (state = defaultDistributorState as IDistributor | null, action: AnyAction) => {
  switch (action.type) {
    case types.GET_DISTRIBUTOR_SUCCESS:
      return action.payload.data.Data as IDistributor
    default:
      return state
  }
}

const defaultDistributorsState: IDistributorResponseData[] = []

export const distributors = (state = defaultDistributorsState, action: AnyAction) => {
  switch (action.type) {
    case types.GET_DISTRIBUTORS_SUCCESS:
      return action.payload.data.Data as IDistributorResponseData[]
    default:
      return state
  }
}
